import script from "./revenueGather.vue?vue&type=script&setup=true&lang=js"
export * from "./revenueGather.vue?vue&type=script&setup=true&lang=js"

import "./revenueGather.vue?vue&type=style&index=0&id=06d95272&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d95272"]])

export default __exports__